import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const propTypes = {
  image: PropTypes.string.isRequired,
  index: PropTypes.number,
  onClickImage: PropTypes.func,
};

function ImageFrameComponent({ image, index, onClickImage }) {
  return (
    <Root image={image}>
      <Positioner>
        <Image image={image} data-photo-index={index} onClick={onClickImage} />
      </Positioner>
    </Root>
  );
}

ImageFrameComponent.propTypes = propTypes;

export default ImageFrameComponent;

const Root = styled.div`
  position: relative;
  width: 100%;
  padding-top: 66.6667%;
  background-image: ${({ image }) => `url("${image}?w=6&h=10&auto=format")`};
  background-size: 100% 100%;
  contain: strict;
  z-index: 0;
`;

const Positioner = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
`;

const Image = styled.div`
  width: 100%;
  height: 100%;
  background-image: ${({ image }) => `url("${image}")`};
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
`;
